import { useMutation } from '@tanstack/react-query'
import { useState } from 'react'
import { Avatar } from '@/features/auth/Avatar'
import { inviteToGame } from './api'
import { useFriends } from './useFriends'

type Props = {
  gameId: string
  /** Кого звать уже не надо: они за столом. Список user_id. */
  seated: number[]
}

/**
 * «Позвать друга» прямо из лобби партии.
 *
 * Список тут же, а не отдельным экраном: уйти со страницы партии, чтобы
 * позвать соперника, значит потерять из виду то, ради чего звали.
 */
export function FriendInvite({ gameId, seated }: Props) {
  const friends = useFriends(true)
  const [called, setCalled] = useState<number[]>([])

  const call = useMutation({
    mutationFn: (userId: number) => inviteToGame(gameId, userId),
    onSuccess: (_result, userId) => setCalled((before) => [...before, userId]),
  })

  const list = (friends.data ?? []).filter((friend) => !seated.includes(friend.id))

  return (
    <div className="card">
      <h2 className="card__title">Позвать друга</h2>

      {list.length === 0 ? (
        <p className="empty">звать некого</p>
      ) : (
        <ul className="people">
          {list.map((friend) => (
            <li key={friend.id} className="person">
              <span className="person__who">
                <Avatar
                  name={friend.nickname ?? friend.name}
                  src={friend.avatar}
                  online={friend.online}
                />
                <span className="person__name">
                  <span className="player__name">{friend.nickname ?? friend.name}</span>
                  <span className="muted">{friend.online ? 'в сети' : 'не в сети'}</span>
                </span>
              </span>

              {called.includes(friend.id) ? (
                <span className="muted">позвали</span>
              ) : (
                <button
                  type="button"
                  className="ghost"
                  disabled={call.isPending}
                  onClick={() => call.mutate(friend.id)}
                >
                  позвать
                </button>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
